// extracted by mini-css-extract-plugin
export default {"sectionHome":"Home_sectionHome__JP0uz","logo":"Home_logo__lvsgx","Hamburguer":"Home_Hamburguer__5CcMh","buttonLogout":"Home_buttonLogout__s5Orr","suggest":"Home_suggest__xNhvu"};